<template>
  <div>
    <div class="card z-depth-5 p-3 mb-4">
      <h6 class="text-center font-weight-bold py-3">Notifications</h6>
      <div class="alert alert-warning text-center font-weight-bold">
        <i class="fas fa-bell"></i> have {{ unreadNotifications }} unread notifications
      </div>
    </div>
    <div class="row">
      <div
        class="col-md-6 mb-4"
        v-for="(notification, index) in notifications"
        :key="index"
      >
        <div
          v-if="!notification.seen"
          class="card z-depth-5 p-3 aqua-gradient white-text"
        >
          <h6 class="font-weight-bold py-3">
            <small>
              <span class="badge badge-warning p-2 mr-2"
                ><i class="fas fa-bell"></i> Unread
              </span>
              <span class="badge badge-dark p-2 mr-2">
                {{ notification.date | moment("dddd, MMMM Do YYYY") }}
              </span>
              <span class="badge badge-primary p-2">
                {{ notification.type }}
              </span>
            </small>
          </h6>
          <p class="blockquote">
            {{ notification.message }}
          </p>
          <div>
            <button
              @click="markNotificationAsRead(notification.date)"
              class="btn btn-block btn-dark"
            >
              Mark as Seen
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div
        class="col-md-6 mb-4"
        v-for="(notification, index) in notifications"
        :key="index"
      >
        <div v-if="notification.seen" class="card z-depth-5 p-3 bg-light">
          <h6 class="font-weight-bold py-3">
            <small>
              <span class="badge badge-success p-2 mr-2"
                ><i class="fas fa-eye"></i> Seen
              </span>
              <span class="badge badge-dark p-2 mr-2">
                {{ notification.date | moment("dddd, MMMM Do YYYY") }}
              </span>
              <span class="badge badge-primary p-2">
                {{ notification.type }}
              </span>
            </small>
          </h6>
          <p class="">
            {{ notification.message }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "TeacherClass",
  components: {},
  data() {
    return {
      fastTeacherToken: localStorage.getItem("fastTeacherToken"),
      fastTeacherId: localStorage.getItem("fastTeacherId"),
      notifications: [],
      unreadNotifications: 0,
      notificationResponse: [],
      entities: [],
      loading: false,
    };
  },

  methods: {
    formatMessage() {
      this.notifications = [];
      this.notificationResponse.data.notifications.forEach((notification) => {
        const startIndex = notification.message.search("{{");
        const endIndex = notification.message.search("}}");
        if (startIndex > -1) {
          const identifier = notification.message.slice(startIndex + 2, endIndex);
          const entity = identifier.replace("{{", "").replace("}}", "");
          const user = this.notificationResponse.data.entities[entity].subject;
          notification.message = notification.message.replace(`{{${identifier}}}`, user);
        }
        this.notifications.push(notification);
      });

      this.notifications.forEach((unread) => {
        if (!unread.seen) {
          this.unreadNotifications++;
        }
      });
    },
    markNotificationAsRead(notifyDate) {
      const config = {
        headers: {
          Authorization: "Bearer " + this.fastTeacherToken,
          "Content-Type": "application/json",
        },
      };
      this.$toast.open({
        message: "Processing : Processing Please Wait...",
        type: "info",
      });
      axios
        .post(this.$apiURI + "/notifications/upto/" + notifyDate + "/seen", {}, config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            this.$toast.open({
              message: "Marked as read",
              type: "success",
            });
            this.loading = false;
            window.location = "";
          }
        })
        .catch((error) => {
          if (error.response.data) {
            this.$toast.open({
              message: "Error : " + error.response.data.message,
              type: "error",
            });
          } else {
            this.$toast.open({
              message: "Network/Server error please refresh try again",
              type: "error",
            });
          }
          this.loading = false;
        });
    },
  },

  mounted() {
    const config = {
      headers: {
        Authorization: "Bearer " + this.fastTeacherToken,
        "Content-Type": "application/json",
      },
    };
    axios
      .get(this.$apiURI + "/notifications", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          this.notificationResponse = response.data;
          this.entities = response.data.data.entities;

          this.formatMessage();
          // eslint-disable-next-line no-console
          // console.log(this.notifications);
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error);
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });
  },
};
</script>
